import { AlertCircle, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const PayrollAlertsPanel = ({
  incompleteEmployees = 0,
  hasIrpsTableForSelectedYear,
  periodYear,
  onResolveIrpsGap,
  configSubmitting = false,
}) => (
  <>
    {incompleteEmployees > 0 && (
      <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5" data-testid="payroll-incomplete-dossiers-alert">
        <AlertTriangle className="mt-0.5 h-5 w-5 text-amber-600" />
        <div>
          <p className="text-sm font-medium text-amber-800">{incompleteEmployees} funcionário(s) com processo incompleto</p>
          <p className="text-xs text-amber-700">Complete o dossier digital (BI, NUIT, INSS, Banco) antes de processar o salário.</p>
        </div>
      </div>
    )}

    {!hasIrpsTableForSelectedYear && (
      <div className="flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 px-3 py-2.5" data-testid="payroll-irps-alert">
        <AlertCircle className="mt-0.5 h-5 w-5 text-red-600" />
        <div className="flex-1">
          <p className="text-sm font-medium text-red-800">Tabela IRPS não configurada para {periodYear}</p>
          <p className="text-xs text-red-700">A folha pode ser gerada, mas deve ficar em revisão até carregar/activar a tabela IRPS oficial do ano seleccionado.</p>
        </div>
        <Button variant="outline" size="sm" onClick={onResolveIrpsGap} disabled={configSubmitting} data-testid="payroll-seed-irps-button">
          {configSubmitting ? 'A activar...' : `Activar oficial ${periodYear}`}
        </Button>
      </div>
    )}
  </>
);